export default "__VITE_ASSET__CrKQelW9__"